import { ArrowRightCircle } from "react-feather";
import { H6, P } from "../../../../../AbstractElements";
import { COMMON_UX_LIST } from "../../../../../Data/UiKit/Modal";
import { UXDesigners } from "../../../../../Constant";

const UXDesigner = () => {
  return (
    <>
      <H6>{UXDesigners}</H6>
      {COMMON_UX_LIST.map((item, index) => (
        <div className="d-flex mt-3" key={index}>
          <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
          <div className="flex-grow-1 ms-2"><P>{item}</P></div>
        </div>
      ))}
    </>
  )
};

export default UXDesigner;